import React from 'react'
import './KarmaRecto.css'

export default function KarmaRecto(props) {

	return <div></div>
}
